export function topBannerCarousel(blockId, autoplaySpeed = 5) {
    $(`#${blockId}`).on('afterChange', (event, slick, currentSlide) => {
        disableInteraction(currentSlide);
    });

    $(`#${blockId}`).on('init', () => {
        disableInteraction(0);
    });

    // Function to disable interaction for all slides except the current one
    function disableInteraction(currentSlide) {
        const blockElement = document.getElementById(blockId);
        const slides = blockElement.querySelectorAll('.slick-slide');

        slides.forEach((slide) => {
            slide.setAttribute('inert', 'true');
            slide.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));

            // Disable interaction for links and buttons inside react-component
            slide
                .querySelector('react-component')
                ?.shadowRoot.querySelectorAll('a, button')
                .forEach((a) => a.setAttribute('tabindex', '-1'));
        });

        const currentSlideElement = slides[currentSlide];

        // Enable interaction for the current slide
        if (currentSlideElement) {
            currentSlideElement.removeAttribute('inert');
            currentSlideElement.querySelectorAll('a').forEach((a) => a.removeAttribute('tabindex'));

            // Enable interaction for links and buttons inside react-component
            currentSlideElement
                .querySelector('react-component')
                ?.shadowRoot.querySelectorAll('a, button')
                .forEach((a) => a.removeAttribute('tabindex'));
        }
    }

    $(`#${blockId}`).slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: autoplaySpeed * 1000,
        arrows: false,
        dots: true,
        fade: true,
        swipe: true,
        speed: 600,
    });
}
